import { render, staticRenderFns } from "./LibraryBaseInfo.vue?vue&type=template&id=62b8d345&scoped=true&"
import script from "./LibraryBaseInfo.vue?vue&type=script&lang=js&"
export * from "./LibraryBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./LibraryBaseInfo.vue?vue&type=style&index=0&id=62b8d345&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b8d345",
  null
  
)

export default component.exports